import { render, staticRenderFns } from "./daySign.vue?vue&type=template&id=1ff0ef1d&scoped=true&"
import script from "./daySign.vue?vue&type=script&lang=js&"
export * from "./daySign.vue?vue&type=script&lang=js&"
import style0 from "./daySign.vue?vue&type=style&index=0&id=1ff0ef1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff0ef1d",
  null
  
)

export default component.exports